import { render, staticRenderFns } from "./GroupManagementSetting.vue?vue&type=template&id=44d97313"
import script from "./GroupManagementSetting.vue?vue&type=script&lang=js"
export * from "./GroupManagementSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports